module.exports = __webpack_public_path__ + "static/assets/ab340b5a979177598eac35ec4ee56e5f.png";